<template>

  <b-container>
  </b-container>
</template>

<script>
export default {
  name: "ShoppingCart",
}
</script>

<style scoped>
</style>